export interface PaymentMethodItem {
  id: string;
  name: string;
  type: PaymentMethodTypes;
  country: string | null;
  brand: PaymentMethodBrands;
  lastFour: string;
  expMonth: number;
  expYear: number;
}

export interface CompanyPaymentMethodResponse {
  count: number;
  paginationToken: string | null;
  items: PaymentMethodItem[];
}
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum PaymentDescriptionText {
  visa = 'paymentMethods.visa',
  mastercard = 'paymentMethods.mastercard',
  discover = 'paymentMethods.discover',
  unionpay = 'paymentMethods.unionpay',
  amex = 'paymentMethods.amex',
  diners = 'paymentMethods.diners',
  bacs_debit = 'paymentMethods.directDebit',
  sepa_debit = 'paymentMethods.directDebit'
}

export type PaymentMethodBrands =
  | 'sepa_debit'
  | 'bacs_debit'
  | 'visa'
  | 'mastercard'
  | 'discover'
  | 'amex'
  | 'unionpay';

export type PaymentMethodTypes = 'card' | 'sepa_debit' | 'bacs_debit';

export interface PaymentMethodCardUI {
  id: string;
  description: PaymentDescriptionText;
  imagePath: string;
  maskedDigits: string;
  expiryDate: Date | null;
  isDefault: boolean;
}

export enum PaymentMethodsIcon {
  DEFAULT = 'bank.svg',
  mastercard = 'mastercard.svg',
  visa = 'visa.svg',
  amex = 'amex.svg',
  unionpay = 'unionpay.svg',
  discover = 'discover.svg',
  sepa_debit = 'sepa.svg',
  bacs_debit = 'bacs.svg',
}

